<script setup>
import {computed, ref} from "vue";
import { Back } from '@element-plus/icons-vue';
import router from "@/router/index.js";
import YTCard from "@/components/YTCard/newIndex.vue";

const props = defineProps({
  // 是否编辑模式
  isEdit: {
    type: Boolean,
    default: false
  },
  // 加载状态
  loading: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['success', 'reGetDetail'])

const back2List = () => {
  router.push("/listBicycleInventory")
}

// 表单信息
const ruleForm = defineModel()
// 表单校验规则
const rules = {
  brandName: [
    {required: true, message: "请输入车辆品牌", trigger: "blur"}
  ],
  model: [
    {required: true, message: "请输入车辆型号", trigger: "blur"}
  ]
}

// 编辑模式
const editMod = ref(false)
const isReadonly = computed(() => props.isEdit && !editMod.value)
const showActionButtons = computed(() => !props.isEdit || editMod.value)
// 处理点击编辑模式
const handleEdit = () => {
  editMod.value = true
}
// 表单锚点
const ruleFormRef = ref()
// 处理表单提交
const submit = () => {
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      try {
        emit("success", ruleForm)
      } catch (e) {
        console.log(e)
      }
    } else {
      ElMessage.error("请根据提示修改表单信息")
    }
  })
}
// 处理新建点击取消
const handleCreateCancel = () => {
  router.back()
}
// 处理编辑点击取消
const handleEditCancel = async () => {
  // 重新请求详情
  emit('reGetDetail')
  // 关闭编辑模式
  editMod.value = false
}
// 处理取消按钮
const handleCancel = () => {
  if (props.isEdit) {
    handleEditCancel()
    return
  }
  handleCreateCancel()
}
</script>

<template>
  <div class="container_box mg_b_2" style="text-align: left;padding: 16px;">
    <div class="flex_center flex_left">
      <div class="flex cursor-pointer" style="gap: 10px;" @click="back2List">
        <el-icon :size="24"><Back /></el-icon>
        <span>返回列表</span>
      </div>
    </div>
  </div>
  <div class="container_box" style="text-align: left;">
    <div>
      <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          style="height: 100%;width: 100%;"
          class="flex"
          size="large"
          v-loading="loading"
      >
        <YTCard :title="`车辆信息`">
          <template #subtitle>
            <div class="flex_center flex_left mg_l_1" v-if="isEdit">
              <el-tag
                  effect="dark"
                  round
                  type="warning"
                  class="mg_r_9"
              >
                已绑定{{ruleForm.boundCount ? ruleForm.boundCount : 0}}辆
              </el-tag>
              <v-btn color="primary" @click="handleEdit" v-if="!editMod">编辑</v-btn>
            </div>
          </template>
          <template #container>
            <el-form-item label="资产归属：" prop="assetOwner">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.assetOwner ? ruleForm.assetOwner : "—" }}
                </template>

                <el-input v-else v-model="ruleForm.assetOwner" :disabled="true"/>
              </div>
            </el-form-item>
            <el-form-item label="车辆品牌：" prop="brandName">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.brandName ? ruleForm.brandName : "—" }}
                </template>

                <el-input v-else v-model="ruleForm.brandName" maxlength="30" show-word-limit placeholder="请输入车辆品牌" />
              </div>
            </el-form-item>
            <el-form-item label="车辆型号：" prop="model">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.model ? ruleForm.model : "—" }}
                </template>

                <el-input v-else v-model="ruleForm.model" maxlength="30" show-word-limit placeholder="请输入车辆型号" />
              </div>
            </el-form-item>
            <el-form-item label="车辆颜色：" prop="color">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.color ? ruleForm.color : "—" }}
                </template>

                <el-input v-else v-model="ruleForm.color" maxlength="20" show-word-limit placeholder="请输入车辆颜色" />
              </div>
            </el-form-item>
            <el-form-item label="车辆使用年龄段：" prop="ageRange">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.ageRange ? ruleForm.ageRange : "—" }}
                </template>

                <el-input v-else v-model="ruleForm.ageRange" maxlength="10" show-word-limit placeholder="请输入年龄段，例如成人、儿童" />
              </div>
            </el-form-item>
            <el-form-item label="提供方/赞助方：" prop="providerSponsor">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.providerSponsor ? ruleForm.providerSponsor : "—" }}
                </template>

                <el-input v-else v-model="ruleForm.providerSponsor" maxlength="30" show-word-limit placeholder="请输入提供方/赞助方" />
              </div>
            </el-form-item>
            <el-form-item label="车辆新旧程度：" prop="conditionLevel">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.conditionLevel ? ruleForm.conditionLevel : "—" }}
                </template>

                <el-input v-else v-model="ruleForm.conditionLevel" maxlength="30" show-word-limit placeholder="请输入车辆新旧程度" />
              </div>
            </el-form-item>
            <el-form-item label="车辆数量：" prop="bicycleQuantity">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.bicycleQuantity || ruleForm.bicycleQuantity === 0 ? ruleForm.bicycleQuantity : "—" }}
                </template>

                <el-input-number v-else v-model="ruleForm.bicycleQuantity" style="width: 300px;" :min="0" show-word-limit placeholder="请输入车辆库存数量" />
              </div>
            </el-form-item>
            <el-form-item label="车辆当前放置场地：" prop="currentVenue">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.currentVenue ? ruleForm.currentVenue : "—" }}
                </template>

                <el-input
                    v-else
                    v-model="ruleForm.currentVenue"
                    maxlength="30"
                    show-word-limit
                    placeholder="请输入放置场地"
                />
              </div>
            </el-form-item>
            <el-form-item label="车辆放置时间：" prop="placementDate">
              <div class="w-100">
                <template v-if="isReadonly">
                  {{ ruleForm.placementDate ? ruleForm.placementDate : "—" }}
                </template>

                <el-date-picker
                    v-else
                    v-model="ruleForm.placementDate"
                    type="date"
                    placeholder="请选择放置时间"
                    value-format="YYYY-MM-DD"
                    style="width: 300px;"
                />
              </div>
            </el-form-item>
            <el-form-item label=" " v-if="showActionButtons">
              <div>
                <v-row>
                  <v-col>
                    <v-btn @click="handleCancel">取消</v-btn>
                  </v-col>
                  <v-col>
                    <v-btn color="primary" @click="submit">保存</v-btn>
                  </v-col>
                </v-row>
              </div>
            </el-form-item>
          </template>
        </YTCard>
      </el-form>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
